/* eslint-disable @typescript-eslint/no-explicit-any */
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import getThemesReducer from './getThemes/reducer';
import loaderReducer from './loader/reducer';
import workspacesReducer from './workspaces/reducer';
import navigationReducer from './navigation/reducer';
import getHeartbeatUpdateData from './heartbeat/reducer';
import { thunk }from 'redux-thunk';

const combiReducers = combineReducers(
  {
    getThemes: getThemesReducer,
    loader: loaderReducer,
    navigation: navigationReducer,
    workspaces: workspacesReducer,
    heartbeatUpdateData: getHeartbeatUpdateData
  }
);

const composeEnhancers = (process.env.NODE_ENV !== 'production' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const store = createStore(
  combiReducers,
  compose(
    applyMiddleware(thunk),
    composeEnhancers()
  )
);

export default store;

